module.exports = __webpack_public_path__ + "static/media/HKGroteskPro-Regular.664e1f14.woff";